import { render, staticRenderFns } from "./segmentraporu.vue?vue&type=template&id=0c541227&"
import script from "./segmentraporu.vue?vue&type=script&lang=js&"
export * from "./segmentraporu.vue?vue&type=script&lang=js&"
import style0 from "./segmentraporu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports